import type { DataProvenance } from '@oxxean/types';
import { formatCoverage, formatDateTime } from '../lib/format';
import { HelpTip } from './primitives';

/**
 * Procedencia del dato (§26).
 *
 * Acompaña a toda pantalla de indicadores y a toda exportación: un número nunca
 * debe circular sin decir de cuándo es, de qué ámbito y con qué cobertura.
 */
export function ProvenanceBar({ provenance }: { provenance: DataProvenance }): JSX.Element {
  const coverage = formatCoverage(provenance.coverage);

  return (
    <div className="provenance">
      <span>
        Período: <strong>{provenance.periodLabel}</strong>
      </span>
      <span>
        Empresa: <strong>{provenance.companyLabel}</strong>
      </span>
      <span>
        Área: <strong>{provenance.areaLabel}</strong>
      </span>
      <span>
        Última sincronización: <strong>{formatDateTime(provenance.lastSyncAt)}</strong>
        {provenance.lastSyncStatus !== null && <> ({provenance.lastSyncStatus})</>}
      </span>
      {coverage !== null && (
        <span>
          Cobertura: <strong>{coverage}</strong>
          <HelpTip text="Proporción de la sincronización del período efectivamente completada. Por debajo del 100 % los indicadores se marcan como parciales." />
        </span>
      )}
      <span>
        Generado: <strong>{formatDateTime(provenance.generatedAt)}</strong>
      </span>
    </div>
  );
}
